<template lang="pug">
v-card(flat)
  v-card-text
    v-form(
      ref="form"
      v-model="valid"
      lazy-validation)
      v-row
        v-col(cols="6")
          v-text-field(
            :rules="[inputRules.requiredInput]"
            v-model="editedItem.name"
            label="Nombre documento"
            hint="Por ejemplo: ESCRITURA 3980"
            persistent-hint
            placeholder="")
        v-col(cols="6")
          v-menu(offset-y min-width="auto" :close-on-content-click="false")
            template(v-slot:activator="{ on, attrs }")
              v-text-field(
                clearable
                @input="$event === '' ? pickerDate=null : pickerDate=$event"
                @click:clear="pickerDate=null"
                v-model="editedItem.date = pickerDate"
                :rules="[inputRules.requiredInput, inputRules.validDate]"
                label="Fecha Documento"
                prepend-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on")
            v-date-picker(
              v-model="pickerDate")
        v-col(cols="6")
          v-text-field(
            v-model="editedItem.number"
            :rules="[inputRules.requiredInput]"
            label="Número Documento"
            hint="Por ejemplo: 3980"
            persistent-hint)
        v-col(cols="6")
          v-text-field(
            v-model="editedItem.entity"
            :rules="[inputRules.requiredInput]"
            label="Entidad Emisora"
            hint="Por ejemplo: NOTARIA 63 DE BOGOTA D.C."
            persistent-hint)
        v-col(cols="6")
          v-autocomplete(
            v-model="editedItem.selected_type"
            :items="documentTypes"
            :rules="[inputRules.requiredSelect]"
            item-value="id"
            item-text="nombre"
            label="Seleccione el Tipo de Documento"
            hint="Por ejemplo: ESCRITURA"
            persistent-hint)
        v-col(cols="6")
          v-autocomplete(
            v-model="selectedCity"
            :loading="loadingCities"
            :items="cities"
            :rules="[inputRules.requiredSelect]"
            :search-input.sync="searchCities"
            cache-items
            class=""
            item-value="codigo"
            item-text="nombre"
            persistent-hint
            hint="Por ejemplo: BOGOTA"
            label="Seleccione la Ciudad/Municipio")
            template(v-slot:selection="data")
              v-chip(
                class="ma-2"
                close
                @click:close="selectedCity = null")
                | {{data.item.nombre}} ({{ data.item.codigo }}) | {{ data.item.dpto_municipio.nombre }}
            template(v-slot:item="data")
              v-list-item-content
                v-list-item-title(v-html="data.item.nombre")
                v-list-item-subtitle(v-html="data.item.dpto_municipio.nombre")
        v-col(cols="12")
          v-file-input(
            :rules="fileRules"
            accept="application/pdf"
            show-size
            v-model="editedItem.file"
            counter
            :label="requiresFile ? 'Ingrese el documento relacionado (requerido)' : 'Ingrese el documento relacionado (opcional)'")
  v-divider(class="mt-12")
  v-card-actions
    v-btn(
      :loading="loading"
      @click="close"
      text) Cerrar
    v-spacer
    v-btn(
      :loading="loading"
      color="primary"
      @click="save"
      text)
      | Guardar
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import commonArkandhaMixin from '@/mixins/commonArkandhaMixin.js';

export default {
  name: 'DocumentForm',

  components: {
  },

  mixins: [commonArkandhaMixin],

  props: {
    annotationData: {
      type: Object,
      default: () => {}
    },
    annotationId: {
      type: String,
      default: ''
    }
  },

  emits: [],

  data() {
    return {
      loading: false,
      defaultItem: {
        name: '',
        number: '',
        date: '',
        entity: '',
        selected_city: null,
        selected_type: null,
        file: null,
        annotation: '',
        document_id: '',
      },
      editedItem: {
        name: '',
        number: '',
        date: '',
        entity: '',
        selected_city: null,
        selected_type: null,
        file: null,
        annotation: '',
        document_id: '',
      },
      valid: true,
      pickerDate: null,
    };
  },

  computed: {
    ...mapState('ui', ['inputRules', 'showDialog', 'currentProperties']),
    ...mapState('documents', ['documentTypes']),
    requiresFile() {
      return Boolean(this.currentProperties.annotationId);
    },
    fileRules() {
      return this.requiresFile ? [this.inputRules.requiredInput] : [];
    },
  },

  watch: {
    showDialog: {
      async handler(newVal) {
        console.log('entro showDialog');
        if (!newVal) {
          this.selectedCity = null;
          return;
        }
        this.editedItem = { ...this.defaultItem };
        this.pickerDate = null;
        this.selectedCity = null;
        this.selectFirstCity = false;
        if ('entity' in this.currentProperties.annotationData) {
          this.editedItem.entity = this.currentProperties.annotationData.entity
        }
        if ('name' in this.currentProperties.annotationData) {
          this.editedItem.name = this.currentProperties.annotationData.name;
        }
        if ('date' in this.currentProperties.annotationData) {
          this.pickerDate = this.currentProperties.annotationData.date;
          this.editedItem.date = this.currentProperties.annotationData.date;
        }
        if ('number' in this.currentProperties.annotationData) {
          this.editedItem.number = this.currentProperties.annotationData.number;
        }
        if ('documentType' in this.currentProperties.annotationData) {
          const filterTypes = this.documentTypes.filter((x) =>
            x.nombre === this.currentProperties.annotationData.documentType);
          if (filterTypes) {
            this.editedItem.selected_type = filterTypes[0].id;
          }
        }
        const annotationData = this.currentProperties.annotationData;
        if ('selectedCityCode' in annotationData) {
          console.log('annotationData if code', annotationData);
          await this.getCities(annotationData.selectedCity);
          this.cities = this.filteredCities;
          this.selectedCity = annotationData.selectedCityCode;
          this.editedItem.selected_city = annotationData.selectedCityCode;
          this.selectFirstCity = false;
        // cargar la ciudad detectada por NER
        } else if ('selectedCity' in annotationData) {
          this.selectFirstCity = true;
          this.searchCities = annotationData.selectedCity;
        }
        if (this.currentProperties.annotationId !== '') {
          this.editedItem.annotation = this.currentProperties.annotationId;
        }
        if (this.currentProperties.documentId) {
          this.editedItem.document_id = this.currentProperties.documentId;
        }
      },
      immediate: true
    }
  },

  mounted() {
  },

  methods: {
    ...mapMutations('ui', ['TOGGLE_DIALOG']),
    ...mapActions('documents', ['saveDocument', 'updateDocument']),
    // metodo para cerrar el modal
    close() {
      this.editedItem = { ...this.defaultItem };
      this.pickerDate = null;
      this.TOGGLE_DIALOG(false);
    },
    // metodo para guardar el documento
    async save() {
      const formValid = this.$refs.form.validate();
      if (!formValid) {
        return;
      }
      this.loading = true;
      // agregar el la ciudad seleccionada del mixin
      this.editedItem.selected_city = this.selectedCity;
      const result = this.editedItem.document_id !== ''
        ? await this.updateDocument(this.editedItem)
        : await this.saveDocument(this.editedItem);
      if (this.editedItem.document_id === '' || result.updated) {
        this.close();
      }
      this.loading = false;
    }
  }
};
</script>

<style scoped>
</style>
